import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { getNPS } from '../../services/api';
import { formatDate } from '../../utils/formatDateTime';

function ScoreBadge({ score }) {
  if (score === null || score === undefined) return <span style={{ color: 'var(--gray-300)' }}>—</span>;
  const color = score >= 9 ? '#10b981' : score >= 7 ? '#f59e0b' : '#ef4444';
  const label = score >= 9 ? 'Promotor' : score >= 7 ? 'Neutro' : 'Detrator';
  return (
    <span style={{ background: color + '20', color, borderRadius: 20, padding: '2px 10px', fontSize: 12, fontWeight: 700 }}>
      {score} · {label}
    </span>
  );
}

function NPSGauge({ nps }) {
  if (nps === null || nps === undefined) return null;
  const color = nps >= 50 ? '#10b981' : nps >= 0 ? '#f59e0b' : '#ef4444';
  return (
    <div style={{ textAlign: 'center', padding: '20px 0' }}>
      <div style={{ fontSize: 56, fontWeight: 800, color }}>{nps}</div>
      <div style={{ fontSize: 14, color: 'var(--gray-500)', marginTop: 4 }}>Net Promoter Score</div>
      <div style={{ fontSize: 12, color: nps >= 75 ? '#10b981' : nps >= 50 ? '#10b981' : nps >= 0 ? '#f59e0b' : '#ef4444', marginTop: 2 }}>
        {nps >= 75 ? 'Excelente' : nps >= 50 ? 'Muito bom' : nps >= 0 ? 'Precisa de atenção' : 'Crítico'}
      </div>
    </div>
  );
}

export default function TenantNPS() {
  const [surveys, setSurveys]  = useState([]);
  const [stats,   setStats]    = useState(null);
  const [total,   setTotal]    = useState(0);
  const [loading, setLoading]  = useState(true);

  useEffect(() => {
    setLoading(true);
    getNPS()
      .then(r => { setSurveys(r.data.surveys || []); setStats(r.data.stats); setTotal(r.data.total || 0); })
      .catch(() => toast.error('Erro ao carregar NPS'))
      .finally(() => setLoading(false));
  }, []);

  const fmt = formatDate;

  return (
    <div className="page-body">
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ margin: 0, color: 'var(--gray-900)', fontSize: 22, fontWeight: 700 }}>NPS — Pesquisa de Satisfação</h1>
        <p style={{ margin: '4px 0 0', color: 'var(--gray-500)', fontSize: 13 }}>
          {total} resposta{total !== 1 ? 's' : ''} coletada{total !== 1 ? 's' : ''}
        </p>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60 }}><div className="spinner" /></div>
      ) : (
        <>
          {stats && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16, marginBottom: 28 }}>
              <div className="card" style={{ padding: 20, textAlign: 'center' }}>
                <NPSGauge nps={stats.nps} />
              </div>
              <div className="card" style={{ padding: 20 }}>
                <div style={{ fontSize: 11, color: 'var(--gray-400)', marginBottom: 6 }}>ENVIADAS</div>
                <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--gray-900)' }}>{stats.total_sent || 0}</div>
                <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>
                  {stats.total_responded || 0} respondidas ({stats.total_sent > 0 ? Math.round((stats.total_responded / stats.total_sent) * 100) : 0}%)
                </div>
              </div>
              <div className="card" style={{ padding: 20 }}>
                <div style={{ fontSize: 11, color: 'var(--gray-400)', marginBottom: 6 }}>PROMOTORES</div>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#10b981' }}>{stats.promoters || 0}</div>
                <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>Nota 9–10</div>
              </div>
              <div className="card" style={{ padding: 20 }}>
                <div style={{ fontSize: 11, color: 'var(--gray-400)', marginBottom: 6 }}>NEUTROS</div>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#f59e0b' }}>{stats.passives || 0}</div>
                <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>Nota 7–8</div>
              </div>
              <div className="card" style={{ padding: 20 }}>
                <div style={{ fontSize: 11, color: 'var(--gray-400)', marginBottom: 6 }}>DETRATORES</div>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#ef4444' }}>{stats.detractors || 0}</div>
                <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>Nota 0–6</div>
              </div>
            </div>
          )}

          <div className="table-container">
            <table className="table">
              <thead><tr>
                <th>Cliente</th><th>Serviço</th><th>Atendimento</th><th>Nota</th><th>Comentário</th><th>Respondido em</th>
              </tr></thead>
              <tbody>
                {surveys.length === 0 ? (
                  <tr><td colSpan={6} style={{ textAlign: 'center', padding: 40, color: 'var(--gray-400)' }}>
                    Nenhuma resposta ainda. As pesquisas são enviadas automaticamente após o atendimento.
                  </td></tr>
                ) : surveys.map(s => (
                  <tr key={s.id}>
                    <td data-label="Cliente">{s.client_name}</td>
                    <td data-label="Serviço">{s.service_name || '—'}</td>
                    <td data-label="Atendimento">{fmt(s.appointment_datetime)}</td>
                    <td data-label="Nota"><ScoreBadge score={s.score} /></td>
                    <td data-label="Comentário" style={{ maxWidth: 240, whiteSpace: 'normal', fontSize: 13, color: 'var(--gray-600)' }}>{s.comment || '—'}</td>
                    <td data-label="Respondido em">{fmt(s.responded_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
